// Libraries
import React from 'react';
import classnames from 'classnames';
import styled from 'styled-components';

// Icons
import './icons.scss';

// Declare type
export interface IIcon extends React.HTMLAttributes<HTMLElement> {
	type?: string;
	className?: string;
	color?: string;
	fontSize?: string;
}

const IconStyled = styled.i<IIcon>`
	color: ${({ color }) => color || '#000'};
	font-size: ${({ fontSize }) => fontSize || '16px'};
`;

const Icon: React.FC<IIcon> = (props) => {
	// Props
	const { type = 'icon-ants-note', onClick, className } = props;

	return <IconStyled {...props} className={classnames(type, className)} onClick={onClick} />;
};

Icon.defaultProps = {
	type: 'icon-ants-note',
};

export default Icon;
